import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { ElaborationOptionsMap } from './CutToSizeMaps'
import {connect} from "react-redux";
import {dispatchPushURL} from "../../store/ui/actions";
import Translation from "../global/Translation";
import Button from "../global/Button";
import {canViewPreorder} from "../../store/login/reducers";
import LocalizedLink from "../global/LocalizedLink";
import backgroundImageFurniture from '../../assets/img/cut-to-size/cts-furniture-img.png'
import planWithInsertsImg from '../../assets/img/cut-to-size/plan-with-inserts-img.svg'
import specialShapesImg from '../../assets/img/cut-to-size/special-shapes-img.svg'
import piecesWithDiffEdgesImg from '../../assets/img/cut-to-size/pieces-with-diff-edges-img.svg'

class ElaborationDetails extends Component {

    render () {
        const {intl, modelImage, hasDetail, showDetail, currentModelOption} = this.props
        const id = this.props.id === 'PREORDER' ? 'BUDGET' : this.props.id
        const option = ElaborationOptionsMap[id]
        const title = intl.formatMessage(option.name)
        const image = modelImage ? (process.env.REACT_APP_API_HOST + modelImage[currentModelOption]) : option.image
        const optionModels = modelImage && modelImage.map((m, index) => {return {image:process.env.REACT_APP_API_HOST + m, index}}).filter(m => m.index !== currentModelOption)

        return (
            <div className="cut_to_size_elaboration_details">
                <div className="cut_to_size_elaboration_details_model_image" style={{ position: 'relative' }}>
                    { id !== 'BUDGET' && <h2 className="questa-bold">{title}</h2>}
                    <img src={image} alt={title} width="100%" />
                    { id !== 'BUDGET' &&
                        <div className="cts-banner-ask-budget" style={{  backgroundImage: `url(${backgroundImageFurniture})`, backgroundPosition: 'auto', backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}>
                            <LocalizedLink routeId={'ROUTE_CUT_TO_SIZE'} header={true} queryString={`?type=${this.props.hasPreOrder ? 'preorder' : 'budget'}`} params={{'outlet':''}}>
                                <div className="cts-banner-ask-budget-container">
                                    <div className="budget-banner-title">
                                        <h2>
                                            <Translation id="do_you_need_to_request_a_special_cut" defaultMessage="Do you need to request a special cut?" />
                                        </h2>
                                    </div>
                                    <div className="cts-banner-ask-budget-content">
                                        <div className="content-image">
                                            <div>
                                                <img src={planWithInsertsImg} alt="Plan with inserts" /> 
                                            </div>
                                            <div>
                                                <h3><Translation id="plan_with_inserts" defaultMessage="Plan with inserts" /></h3>
                                            </div>
                                        </div>
                                        <div className="content-image">
                                            <div>
                                                <img src={specialShapesImg} alt="Special shapes" /> 
                                            </div>
                                            <div>
                                                <h3><Translation id="special_shapes" defaultMessage="Special shapes" /></h3>
                                            </div>
                                        </div>
                                        <div className="content-image">
                                            <div>
                                                <img src={piecesWithDiffEdgesImg} alt="Pieces with different edges" /> 
                                            </div>
                                            <div>
                                                <h3><Translation id="pieces_with_different_edges" defaultMessage="Pieces with different edges" /></h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <Button customClass="bt-cts-inverted">
                                        <Translation id="request_for_quote" defaultMessage="Request for quote" />
                                    </Button>
                                    </div>
                                </div>
                            </LocalizedLink>
                        </div>
                    }

                    {hasDetail && (
                        <div
                            style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%)',
                                borderRadius: '100%',
                                backgroundColor: '#D8D8D8',
                                opacity: '0.65',
                                width: '48px',
                                height: '48px',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                            onClick={showDetail}
                        >
                            <i className="fas fa-search-plus 2x" style={{ margin: 'auto', color: 'black', fontSize: '1.4em', fontWeight: '500' }} />
                        </div>
                    )}
                </div>
                {optionModels && optionModels.length > 0 && (
                    <div className="cut_to_size_elaboration_details_model_options mt-3">
                        {optionModels.map(option => {
                            const key = 'option-' + option.index

                            return (
                                <div className="cut_to_size_elaboration_details_model_option m-2 p-2" key={key}>
                                    <img
                                        src={option.image}
                                        alt={key}
                                        height="100px"
                                        onClick={() => {
                                            this.props.setCurrentModelOption(option.index)
                                        }}
                                    />
                                </div>
                            )
                        })}
                    </div>
                )}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        hasPreOrder: canViewPreorder(state)
    }
}
const mapDispatchToProps = dispatch => {
    return {
        goToURL: url => {
            return dispatch(dispatchPushURL(url, 1))
        }
    }
}

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ElaborationDetails)
)
